import {fromJS, Map} from 'immutable';
import gameXpHighlightsActions from '../../actions/fortnite-game/gameXpHighlights.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export interface HighlightsDatapoint {
    stats: number[];
    value: number;
    trend: number;
}

interface HighlightsData {
    activations: HighlightsDatapoint;
    players: HighlightsDatapoint;
    percentile: HighlightsDatapoint;
}

export interface GameXpHighlightsState {
    data: HighlightsData;
    loading: boolean;
    error?: string;
}

export const DEFAULT_STATE = fromJS({
    data: {activations: [], players: [], xpPerMinute: []},
    loading: false,
    error: undefined
});

export const gameXpHighlightsReducer = (
    state: Map<GameXpHighlightsState, any> = DEFAULT_STATE,
    action
) => {
    const {data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case gameXpHighlightsActions.TYPES.GET_GAME_XP_HIGHLIGHTS: {
            return state.merge({
                error: undefined,
                loading: !silent
            });
        }

        case gameXpHighlightsActions.TYPES.GET_GAME_XP_HIGHLIGHTS_COMPLETE: {
            return state.merge({
                data,
                loading: false,
                error
            });
        }

        case gameXpHighlightsActions.TYPES.GET_GAME_XP_HIGHLIGHTS_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('gameXpHighlights', gameXpHighlightsReducer);
